import { render, staticRenderFns } from "./ClassificationRequests.vue?vue&type=template&id=660487a6&scoped=true&"
import script from "./ClassificationRequests.vue?vue&type=script&lang=js&"
export * from "./ClassificationRequests.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationRequests.vue?vue&type=style&index=0&id=660487a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660487a6",
  null
  
)

export default component.exports